module.exports = __webpack_public_path__ + "assets/img/3_1335.0733b4bc.jpg";